var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 74,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M1.247 51.824h3.731c1.497 6.781 1.574 6.51 2.721 11.513 0-2.608-.097-8.907-.097-11.513h2.788V68.71H6.562c-1.584-6.646-1.71-7.015-2.537-11.126V68.71h-2.78V51.824h.002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M17.999 51.823h.611v2.787H14.734v4.266h2.302V61.653h-2.302v4.275H18.61v2.778H11.957V51.822h6.041v.001Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M26.2 52.93a3.6 3.6 0 0 1 1.098 2.643v9.396c0 1.024-.365 1.904-1.098 2.642-.733.732-1.613 1.098-2.642 1.098-1.043 0-1.924-.366-2.643-1.098a3.6 3.6 0 0 1-1.098-2.642v-9.396c0-1.037.366-1.917 1.098-2.642.725-.74 1.606-1.108 2.643-1.108 1.022 0 1.903.369 2.642 1.108Zm-3.323 1.964a.928.928 0 0 0-.282.68v9.396a.93.93 0 0 0 .282.68c.194.188.42.283.68.283.246 0 .47-.095.67-.282a.928.928 0 0 0 .282-.68v-9.396a.928.928 0 0 0-.282-.68.916.916 0 0 0-.67-.283.922.922 0 0 0-.68.282Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M28.707 51.823h3.73c1.498 6.782 1.575 6.51 2.722 11.513 0-2.608-.098-8.907-.098-11.513h2.789V68.71h-3.829c-1.583-6.646-1.71-7.015-2.537-11.125v11.125h-2.779V51.823h.002Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M46.527 51.833h.447l.136.427.972 3.206.399 1.331.408-1.331.972-3.206.126-.427h2.905l-.233.776-2.322 7.656 2.322 7.656.233.786h-2.905l-.126-.427-.972-3.206-.408-1.34-.4 1.34-.971 3.206-.136.427H44.07l.242-.786 2.313-7.656-2.313-7.656-.242-.776h2.458Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M54.476 68.709h-.602V51.823h3.148c1.14 0 2.114.405 2.924 1.215s1.215 1.784 1.215 2.924v3.13c0 1.14-.405 2.114-1.215 2.924s-1.785 1.215-2.924 1.215h-.369v5.478h-2.177Zm2.176-8.267h.368c.369 0 .687-.133.952-.399.266-.252.399-.57.399-.951v-3.13c0-.376-.133-.693-.399-.951a1.298 1.298 0 0 0-.952-.399h-.368v5.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M63.124 68.709h-.602V51.825h3.245c1.14 0 2.114.405 2.924 1.215s1.215 1.783 1.215 2.924v2.526c0 1.049-.448 1.963-1.147 2.74.7.783 1.147 1.697 1.147 2.74v3.187c-.026.68.058 1.198.252 1.555H67.38a1.684 1.684 0 0 1-.214-.718 12.862 12.862 0 0 1-.05-.835V63.97c0-.375-.132-.693-.398-.951a1.298 1.298 0 0 0-.952-.4H65.3V68.713h-2.176v-.003Zm2.176-8.87h.564c.369 0 .687-.133.952-.4.266-.266.398-.582.398-.951v-2.526c0-.376-.132-.693-.398-.951a1.298 1.298 0 0 0-.952-.399H65.3v5.226Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M77.475 51.823h.611v2.787H74.21v4.266h2.302V61.653H74.21v4.275H78.086v2.778h-6.654V51.822H77.474v.001Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M82.887 68.709c-2.037 0-3.605-1.677-3.605-3.74V63.18h2.682v1.789c0 .535.413.96.923.96.46 0 .797-.419.797-.96v-.884c0-.925-.772-1.544-1.156-2.022-.758-.942-2.001-2.007-2.468-2.663-.553-.776-.847-1.96-.874-2.555l-.04-1.273c0-2.07 1.663-3.75 3.702-3.75 2.03 0 3.516 1.665 3.516 3.75v1.778h-2.681v-1.778c0-.533-.333-.963-.798-.963-.521 0-.923.435-.923.963v.709c.007.291.203.99.467 1.369.444.643 1.106 1.123 1.418 1.448 1.098 1.136 1.545 1.51 1.894 2.138.427.767.709 1.758.709 2.439l.009 1.292c.005 2.102-1.546 3.742-3.572 3.742Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M91.176 68.709c-2.037 0-3.605-1.677-3.605-3.74V63.18h2.682v1.789c0 .535.413.96.923.96.46 0 .797-.419.797-.96v-.884c0-.925-.772-1.544-1.156-2.022-.758-.942-2.001-2.007-2.467-2.663-.555-.776-.848-1.96-.875-2.555l-.04-1.273c0-2.07 1.663-3.75 3.702-3.75 2.03 0 3.517 1.665 3.517 3.75v1.778h-2.682v-1.778c0-.533-.332-.963-.797-.963-.522 0-.924.435-.924.963v.709c.007.291.204.99.467 1.369.444.643 1.106 1.123 1.418 1.448 1.098 1.136 1.546 1.51 1.894 2.138.427.767.709 1.758.709 2.439l.01 1.292c.002 2.102-1.546 3.742-3.573 3.742Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillRule: "evenodd",
    d: "M44.79 33.537a109.173 109.173 0 0 0-3.371 3.685l-2.302-.47a87.822 87.822 0 0 1 4.575-4.506 84.324 84.324 0 0 0-2.57-2.833c-6.855 5.33-12.905 11.406-18.885 18.217h7.844a97.34 97.34 0 0 1 6.625-8.268l2.444.534c-2.263 2.722-3.815 5.023-5.713 7.734h6.849c2.223-3.72 4.588-7.312 7.172-10.739a94.066 94.066 0 0 0-2.667-3.354Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    fillRule: "evenodd",
    d: "M48.7 24.061c.144.095.291.188.436.284.745.491 1.486.992 2.22 1.504a89.392 89.392 0 0 1 3.027-2.182l.882.38a93.64 93.64 0 0 0-2.998 2.445c.838.597 1.67 1.21 2.497 1.84 7.413-7.622 16.549-14.044 28.555-18.69-14.168 3.603-25.226 8.42-34.62 14.42Zm8.905-1.78-.706-.298a84.18 84.18 0 0 1 9.132-5.126 83.954 83.954 0 0 0-8.426 5.424Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    fillRule: "evenodd",
    d: "M39.101 21.983a84.18 84.18 0 0 0-9.132-5.126 83.662 83.662 0 0 1 8.426 5.422l.706-.296Zm8.683 6.338a90.941 90.941 0 0 0-6.165-4.654l-.883.38a95.607 95.607 0 0 1 5.599 4.733l1.45-.459Zm9.1 8.432c-2.227-2.353-4.256-4.275-6.806-6.497l-1.618.52c2.2 2.123 4.183 4.232 6.121 6.446l2.302-.47Zm16.879 10.876C58.199 29.902 42.172 17.143 12.68 9.639c21.17 8.192 33.419 21.908 43.033 37.99h6.85c-1.9-2.712-3.451-5.012-5.714-7.735l2.444-.534a97.621 97.621 0 0 1 6.625 8.269h7.844Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m87.023 9.773 1.07 7.893.955-.334 2.257-8.98c2.554-.973 3.817-1.763 4.436-2.324.515-.466.214-1.328-.48-1.37-.836-.053-2.314.12-4.918.951L82.978 0l-.954.334 4.088 6.835c-.551.225-1.133.47-1.744.733-.939.431-1.78.846-2.505 1.227l-3.756-2.86-.519.182 2.288 3.824c-.643.422-.974.727-.926.864.047.138.498.17 1.263.098l.599 4.415.518-.181 1.152-4.579a54.55 54.55 0 0 0 2.724-.603c.64-.175 1.247-.349 1.817-.516Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m8.977 9.773-1.07 7.893-.955-.334-2.258-8.98C2.14 7.38.878 6.59.26 6.028-.256 5.562.045 4.7.74 4.658c.836-.053 2.314.12 4.918.951L13.022 0l.954.334-4.088 6.835c.551.225 1.133.47 1.744.733.939.431 1.78.846 2.505 1.227l3.756-2.86.519.182-2.288 3.824c.643.422.974.727.926.864-.049.138-.498.17-1.263.098l-.599 4.415-.518-.181-1.152-4.579a54.526 54.526 0 0 1-2.724-.603c-.64-.175-1.247-.349-1.817-.516Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0563CA",
    d: "M95.044 72.358H.954v1.278h94.09v-1.278Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 5.454,
    x2: 5.884,
    y1: -6.133,
    y2: 72.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 14.918,
    x2: 15.348,
    y1: -6.186,
    y2: 72.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 23.192,
    x2: 23.622,
    y1: -6.231,
    y2: 72.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 32.913,
    x2: 33.343,
    y1: -6.285,
    y2: 72.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 48.114,
    x2: 48.545,
    y1: -6.368,
    y2: 71.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 57.139,
    x2: 57.57,
    y1: -6.418,
    y2: 71.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 65.927,
    x2: 66.357,
    y1: -6.466,
    y2: 71.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 74.392,
    x2: 74.823,
    y1: -6.513,
    y2: 71.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 82.438,
    x2: 82.868,
    y1: -6.557,
    y2: 71.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 90.726,
    x2: 91.156,
    y1: -6.603,
    y2: 71.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 34.58,
    x2: 35.01,
    y1: -6.294,
    y2: 72.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 65.88,
    x2: 66.311,
    y1: -6.466,
    y2: 71.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 43.03,
    x2: 43.461,
    y1: -6.34,
    y2: 71.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 86.725,
    x2: 87.155,
    y1: -6.581,
    y2: 71.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 9.14,
    x2: 9.57,
    y1: -6.154,
    y2: 72.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ea5e5b405999be2fef47bc77a8bd74b.svg";
export { ForwardRef as ReactComponent };